import React, { useState } from 'react';
import { useSelector } from '@xstate/react';
import { Modal, useModalVariant } from '@chargify/custom-ui-components';

import { Content } from './components';

import { useServices } from '../../hooks';
import { modalsSelectors } from '../../machines';

const ChangeSubscriptionPlan = () => {
  const [closeDisable, setCloseDisable] = useState(false);
  const { modalsService } = useServices();
  const modalVariant = useModalVariant();
  const { isOpen, meta } = useSelector(
    modalsService,
    modalsSelectors.getChangeSubscriptionPlan
  );

  const closeHandler = (successUpdate?: boolean) => {
    if (!closeDisable || successUpdate)
      modalsService.send({ type: 'CLOSE_MODAL' });
  };
  return (
    <Modal
      isOpen={isOpen}
      onClose={() => closeHandler()}
      variant={modalVariant}
      width="100%"
    >
      <Content
        {...meta}
        displayMode={modalVariant}
        onProcessingUpdate={(isProcessing) => setCloseDisable(isProcessing)}
        onClose={closeHandler}
      />
    </Modal>
  );
};

export default ChangeSubscriptionPlan;
